import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'

export const PLATFORM_DISPLAY_NAMES: Record<ExternalIntegrationEnum, string> = {
  [ExternalIntegrationEnum.LinkedIn]: 'LinkedIn',
  [ExternalIntegrationEnum.Instagram]: 'Instagram',
  [ExternalIntegrationEnum.X]: 'X/Twitter',
  [ExternalIntegrationEnum.WordPress]: 'WordPress',
  [ExternalIntegrationEnum.Facebook]: 'Facebook',
  [ExternalIntegrationEnum.TikTok]: 'TikTok',
  [ExternalIntegrationEnum.YouTube]: 'YouTube',
  [ExternalIntegrationEnum.Mailchimp]: 'Mailchimp',
  [ExternalIntegrationEnum.Google]: 'Google',
  [ExternalIntegrationEnum.GoogleDrive]: 'Google Drive',
  [ExternalIntegrationEnum.GoogleBusinessProfile]: 'Google Business Profile',
  [ExternalIntegrationEnum.MetaAds]: 'Meta Ads',
  [ExternalIntegrationEnum.GoogleAds]: 'Google Ads',
  [ExternalIntegrationEnum.GoHighLevel]: 'GoHighLevel',
  [ExternalIntegrationEnum.Wix]: 'Wix',
  [ExternalIntegrationEnum.Shopify]: 'Shopify',
}

export const getPlatformDisplayName = (provider: ExternalIntegrationEnum): string => {
  return PLATFORM_DISPLAY_NAMES[provider] || provider
}

export const isCharacterLimitError = (errorMessage: string): boolean => {
  return errorMessage.includes('character limit') || errorMessage.includes('Content exceeds')
}
